const tbobookingnonlcc = (
	location,
	response,
	invoice,
	dispatch,
	agentInfo,
	fareQuoteEtrav,
	payment,
	FlightBookEtravDispatch,
	history,
	FlightTicketLCCDispatch,
	FlightBookDispatch
) => {
	let formData = {
		TraceId: location.state.IDTBO,
		ResultIndex: location.state.OneflightData.ResultIndex,
		orderId: location.state.orderID,
		paymentId: response === 'success' ? invoice : response.razorpay_payment_id,
		Passengers: location.state.BookingData.map((item) => {
			return {
				Title: item.title,
				FirstName: item.first_name,
				LastName: item.last_name,
				PaxType: item.PaxType,
				DateOfBirth: item.dob,
				Gender: 1,
				// PassportNo: location.state.formData
				// 	? location.state.formData.data.passport
				// 	: '',
				// PassportExpiry: '2023-12-06T00:00:00',
				AddressLine1: 'hello',
				AddressLine2: '',
				Fare: {
					Currency: location.state.OneflightData
						? location.state.OneflightData.Fare.Currency
						: '',
					BaseFare: location.state.OneflightData
						? location.state.OneflightData.Fare.OfferedFare
						: '',
					Tax: location.state.OneflightData
						? location.state.OneflightData.Fare.Tax
						: '',
					YQTax: location.state.OneflightData
						? location.state.OneflightData.Fare.YQTax
						: '',
					AdditionalTxnFeePub: location.state.OneflightData
						? location.state.OneflightData.Fare.AdditionalTxnFeePub
						: '',
					AdditionalTxnFeeOfrd: location.state.OneflightData
						? location.state.OneflightData.Fare.AdditionalTxnFeeOfrd
						: '',
					OtherCharges: location.state.OneflightData
						? location.state.OneflightData.Fare.OtherCharges
						: '',
					Discount: location.state.OneflightData
						? location.state.OneflightData.Fare.Discount
						: '',
					PublishedFare: location.state.OneflightData
						? location.state.OneflightData.Fare.PublishedFare
						: '',
					OfferedFare: location.state.OneflightData
						? location.state.OneflightData.Fare.OfferedFare
						: '',
					TdsOnCommission: location.state.OneflightData
						? location.state.OneflightData.Fare.TdsOnCommission
						: '',
					TdsOnPLB: location.state.OneflightData
						? location.state.OneflightData.Fare.TdsOnPLB
						: '',
					TdsOnIncentive: location.state.OneflightData
						? location.state.OneflightData.Fare.TdsOnIncentive
						: '',
					ServiceFee: location.state.OneflightData
						? location.state.OneflightData.Fare.ServiceFee
						: '',
				},
				City: '',
				CountryCode: 'IN',
				CellCountryCode: '+91',
				ContactNo: location.state.formData ? location.state.formData.phone : '',
				Nationality: 'IN',
				Email: location.state.formData ? location.state.formData.email : '',
				IsLeadPax: true,
				FFAirlineCode: null,
				FFNumber: '',
				GSTCompanyAddress: '',
				GSTCompanyContactNumber: '',
				GSTCompanyName: '',
				GSTNumber: '',
				GSTCompanyEmail: '',
			};
		}),
		Baggage: [],
		MealDynamic: [],
		SeatDynamic: [],
	};
	dispatch(FlightBookDispatch(formData, history, location.state.IDTBO));
	
};

export default tbobookingnonlcc;
